import SceneObject from "../scene/sceneobject";
import Navigator from "./navigator";

export default abstract class Brain {
  protected owner: SceneObject | null = null;
  protected navigator: Navigator | null = null;

  attach(owner: SceneObject, navigator: Navigator): void {
    this.owner = owner;
    this.navigator = navigator;
  }

  abstract tick(delta_time: number): void;
}